import axios from 'axios';
import constants from '../../config/constants';

export const GET_ALL_ADMISSIONS = 'GET_ALL_ADMISSIONS';
export const GET_ADMISSION = 'GET_ADMISSION';
export const GET_ADMISSION_BY_NUMBER = 'GET_ADMISSION_BY_NUMBER';
export const GET_ADMISSION_BY_NUMBER_AND_ID = 'GET_ADMISSION_BY_NUMBER_AND_ID';

//= ========== Reducer call functions begin ===========//
export const getAllAdmissions = admissionData => ({
  type: GET_ALL_ADMISSIONS,
  admissionData,
});

export const getAdmission = admission => ({
  type: GET_ADMISSION,
  admission,
});

export const getAdmissionByNumber = admissionByNumber => ({
  type: GET_ADMISSION_BY_NUMBER,
  admissionByNumber,
});

export const getAdmissionByNumberAndId = admissionByNumberAndId => ({
  type: GET_ADMISSION_BY_NUMBER_AND_ID,
  admissionByNumberAndId,
});
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const fetchAllAdmissionsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/all-admission-form/${data.status}${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    return dispatch(getAllAdmissions(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const saveAdmissionService = data => () => {
  return axios.post(`${constants.API_BASE_URL}/api/admission-form`, data.postData, constants.setHeader(data.token));
};

export const fetchAdmissionService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admission-form/${data.admissionId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getAdmission(res.data));
};

export const deleteAdmissionService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admission/delete-school-admission/${data.admissionId}`,
    constants.setHeader(data.token)
  );
};

// Non-auth admission API's
export const updateAdmissionService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/update-admission-form/${data.admissionId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchAdmissionByNumberService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/auth/my-admission-form/${data.schoolId}/${data.phoneNumber}`,
    constants.setHeader(data.token)
  );
  return dispatch(getAdmissionByNumber(res.data));
};

export const fetchAdmissionByNumberAndIdService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/auth/view-admission-form/${data.schoolId}/${data.phoneNumber}/${data.admissionId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getAdmissionByNumberAndId(res.data));
};
//= ========== User routing end ===========//
